import { BaseClientType, EditClientStepProps } from '../../types';
import { Box, Divider, TextField, Typography } from '@mui/material';
import { Controller, useFieldArray } from 'react-hook-form';
import { JSX } from 'react';
import {
  validationRegExpPatterns,
  validationsErrorMessages,
} from '../../../common/lib/validations';
import AsyncFormSelect from '../../../common/components/form/asyncFormSelect';
/**
 * Client addresses edit form
 */
const EditClientAddresses = ({ control }: EditClientStepProps<BaseClientType>): JSX.Element => {
  const { fields: addressFields } = useFieldArray({
    control,
    name: 'addresses',
  });

  return (
    <Box>
      {addressFields.map((field, index) => (
        <Box key={field.id} className="mt-10">
          <Typography variant="h6">{field.typeNote}</Typography>
          <Divider />
          <Box key={field.id} className="mt-4 grid gap-8 md:grid-cols-2">
            <Controller
              name={`addresses.${index}.street`}
              control={control}
              rules={{
                pattern: {
                  value: validationRegExpPatterns.addressPattern,
                  message: validationsErrorMessages.invalidCharacters,
                },
              }}
              render={({ field, fieldState: { error } }): JSX.Element => (
                <TextField
                  {...field}
                  label="Street address"
                  placeholder="e.g. 15 Rosehill Drive"
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
            <Controller
              name={`addresses.${index}.city`}
              control={control}
              rules={{
                pattern: {
                  value: validationRegExpPatterns.addressPattern,
                  message: validationsErrorMessages.invalidCharacters,
                },
              }}
              render={({ field, fieldState: { error } }): JSX.Element => (
                <TextField
                  {...field}
                  label="City"
                  placeholder="e.g. Johannesburg"
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
            <Controller
              name={`addresses.${index}.province`}
              control={control}
              render={({ field, fieldState: { error } }): JSX.Element => (
                <AsyncFormSelect
                  {...field}
                  valueKey="note"
                  label="Province"
                  error={Boolean(error)}
                  optionsEndpoint="/Provinces"
                />
              )}
            />
            <Controller
              name={`addresses.${index}.country`}
              control={control}
              render={({ field, fieldState: { error } }): JSX.Element => (
                <AsyncFormSelect
                  {...field}
                  label="Country"
                  valueKey="note"
                  error={Boolean(error)}
                  optionsEndpoint="/ProvinceCountrys"
                />
              )}
            />
            <Controller
              name={`addresses.${index}.code`}
              rules={{
                pattern: {
                  value: validationRegExpPatterns.postalCodePatters,
                  message: validationsErrorMessages.postalCode,
                },
              }}
              control={control}
              render={({ field, fieldState: { error } }): JSX.Element => (
                <TextField
                  {...field}
                  type="number"
                  label="Postal code"
                  placeholder="e.g. 1234"
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default EditClientAddresses;
